import React from "react";
import { Link } from "react-router-dom";

// import "./articleCard.styles.scss"; 

function ArticleCard({ data, isFeatured }) {
  const { title, publishDate, category, description, id, ArticleMedia } = data;

  // Lógica de fecha
  const dateObj = new Date(publishDate);
  const formattedDate = `${dateObj.getDate().toString().padStart(2, "0")}/${(
    dateObj.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${dateObj.getFullYear()}`;

  // Nueva lógica de imagen basada en tu ejemplo
  const imageUrl = ArticleMedia != null && ArticleMedia.url
    ? `${process.env.REACT_APP_HOME_API_URL}${ArticleMedia.url}`
    : "https://placehold.co/400x250"; 
    
  return (
    <article className="article-card-horizontal">
      <div className="row g-0">
        
        {/* Columna de Imagen */}
        <div className="col-12 col-md-5 image-wrapper">
          <Link to={`/blog/${id}`}>
            <img src={imageUrl} alt={title || "Artículo del blog"} className="article-img" />
          </Link>
        </div>

        {/* Columna de Contenido */}
        <div className="col-12 col-md-7 content-wrapper">
          
          <Link to={`/blog/${id}`} className="text-decoration-none">
            <h2 className={`article-title ${isFeatured ? 'featured' : ''}`}>
              {title}
            </h2>
          </Link>
          
          <div className="article-meta">
            <span className="meta-date">{formattedDate}</span>
            <span className="meta-category">{category?.name || 'Categoría'}</span>
          </div>
          
          <p className="article-excerpt">
            {description}
          </p>
          
          <Link to={`/blog/${id}`} className="btn-saber-mas text-decoration-none text-center">
            Saber más
          </Link>

        </div>

      </div>
    </article>
  );
}

export default ArticleCard;

/* import React from "react";
import { Link } from "react-router-dom";

// Custom styles
import "./articleCard.styles.scss";

// Assets
import arrowFigure from "../../assets/images/arrow.svg";

function ArticleCard({ data }) {
  const { title, publishDate, category, description, id } = data;
  const date = new Date(publishDate);
  const formattedDate = `${date.getDate().toString().padStart(2, "0")}/${(
    date.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${date.getFullYear()}`;
  // console.log(category);
  return (
    <Link to={`/blog/${id}`} className="card__link">
      <div className="card">
        <div className="card__published__at">
          <p>{formattedDate}</p>
        </div>
        <div className="card__heading">
          <h6>AFIX SERVICIOS FINANCIEROS</h6>
          <h5>{category.name}</h5>
        </div>
        <div className="card__body">
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
        <div className="card__footer">
          <img src={arrowFigure} alt="" />
        </div>
      </div>
    </Link>
  );
}

export default ArticleCard;
 */
